import styled from '@emotion/styled'
import { css } from '@emotion/react'

const buttonCloseStyles = ({ theme }) => css`
  label: modal__button-close;

  position: absolute;
  top: ${theme.spacings.mega};
  left: ${theme.spacings.mega};
  color: ${theme.colors.n400};

  ${theme.media.mega} {
    display: none;
  }
`

const buttonCloseTextStyles = ({ theme }) => css`
  label: modal__button-text;

  position: absolute;
  top: -28px;
  right: 0;
  display: none;
  align-items: center;
  font-size: ${theme.typography.subHeadings.kilo.fontSize};
  color: ${theme.colors.white};
  cursor: pointer;

  svg {
    display: block;
    width: 10px;
    height: 10px;
    margin-left: ${theme.spacings.byte};
  }

  ${theme.media.mega} {
    display: flex;
  }
`

export const ButtonClose = styled('div')(buttonCloseStyles)
export const ButtonCloseText = styled('span')(buttonCloseTextStyles)
